import state from '../state';

class Points {
  constructor() {
    this.timer = -1;
    this.startable = false;
  }

  start() {
    this.timer = window.setInterval(() => this.scorePoint(), 1000);
  }

  stop() {
    window.clearInterval(this.timer);
  }

  scorePoint() {
    state.score += 1;
  }
}

export default Points;
